import { render, staticRenderFns } from "./markdown.vue?vue&type=template&id=bf40b4c2&"
import script from "./markdown.vue?vue&type=script&lang=js&"
export * from "./markdown.vue?vue&type=script&lang=js&"
import style0 from "./markdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports